module.exports = __webpack_public_path__ + "f0e0011ec8e246e6f7bbffb274abd105.webp";